import { render, staticRenderFns } from "./UnifiedSearchPage.vue?vue&type=template&id=79506776&scoped=true&"
import script from "./UnifiedSearchPage.vue?vue&type=script&lang=js&"
export * from "./UnifiedSearchPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79506776",
  null
  
)

export default component.exports